import { type SVGProps } from "react"

export function Connector1(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={206}
            height={109}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M204 0a2 2 0 0 1 2 2v6.8a2 2 0 1 1-4 0V2a2 2 0 0 1 2-2m0 15.868a2 2 0 0 1 2 2v13.601a2 2 0 1 1-4 0V17.868a2 2 0 0 1 2-2m0 22.669a2 2 0 0 1 2 2v8.8h-7.94a2 2 0 1 1 0-4H202v-4.8a2 2 0 0 1 2-2m-200 6.8h7.94a2 2 0 0 1 0 4H8v4.4a2 2 0 0 1-4 0zm13.86 2a2 2 0 0 1 2-2h11.88a2 2 0 0 1 0 4H19.86a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 0 1 0 4H39.66a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 0 1 0 4H59.46a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 0 1 0 4H79.26a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 1 1 0 4H99.06a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 1 1 0 4h-11.88a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 1 1 0 4h-11.88a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 1 1 0 4h-11.88a2 2 0 0 1-2-2m19.8 0a2 2 0 0 1 2-2h11.88a2 2 0 1 1 0 4h-11.88a2 2 0 0 1-2-2M6 60.27a2 2 0 0 1 2 2v12.799a2 2 0 1 1-4 0V62.269a2 2 0 0 1 2-2m0 21.332a2 2 0 0 1 2 2V90a2 2 0 1 1-4 0v-6.4a2 2 0 0 1 2-2"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={103}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}
